// ─── Fase 16B · Bloque 3 — Funnel tracking ────────────────────────────────
// Thin wrapper around @vercel/analytics if present. If not installed, all
// calls are no-ops (errors swallowed).
let vaTrack = null;
if (typeof window !== "undefined") {
  // Dynamic import so webpack doesn't fail if @vercel/analytics isn't installed.
  import(/* webpackIgnore: true */ "@vercel/analytics")
    .then(m => { vaTrack = m.track; })
    .catch(() => { /* analytics not installed — ok */ });
}

export function track(event, props) {
  try {
    if (vaTrack) vaTrack(event, props);
  } catch { /* noop */ }
}

// Session-scoped "first time" guard for events fired per page-view
const fired = new Set();
export function trackOnce(event, props) {
  if (fired.has(event)) return;
  fired.add(event);
  track(event, props);
}
